import React, { forwardRef, useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';
import { QRCodeSVG } from 'qrcode.react';
import { generateQRUrl } from '../config/qrConfig';
import './PrintView.css';

const PrintView = forwardRef(({ item, quantity }, ref) => {
  if (!item) return null;

  // Format date in reverse order without slashes (matching preview)
  const today = new Date();
  const year = today.getFullYear().toString().slice(-2); // Last 2 digits of year
  const month = (today.getMonth() + 1).toString().padStart(2, '0');
  const day = today.getDate().toString().padStart(2, '0');
  // Reverse the order: year (reversed) + month (reversed) + day (reversed)
  const formattedDate = year.split('').reverse().join('') +
                        month.split('').reverse().join('') +
                        day.split('').reverse().join('');

  // Determine logo based on SKU prefix
  const getLogo = () => {
    const sku = item.sku?.toUpperCase() || '';
    if (sku.startsWith('RW')) {
      return '/rewined_logo.jpg';
    } else if (sku.startsWith('CF')) {
      return '/candlefish_logo.jpg';
    }
    return null;
  };

  const logoSrc = getLogo();

  // Generate QR code URL for mobile operations
  // IMPORTANT: This URL is printed on physical labels that may last 1+ years
  const qrUrl = generateQRUrl(item.sku);

  const labels = [];
  for (let i = 0; i < quantity; i++) {
    labels.push(
      <div key={i} className="print-label">
        <div className="print-label-content">
          <div className="print-label-top-section">
            <div className="print-label-left-column">
              {logoSrc ? (
                <img src={logoSrc} alt="Brand Logo" className="print-label-logo" />
              ) : (
                <div className="print-label-brand">{typeof item.brand === 'object' ? item.brand.refName || '' : item.brand || ''}</div>
              )}
              <div className="print-label-barcode-section">
                <BarcodeImage sku={item.sku} />
              </div>
              <div className="print-label-sku">{item.sku}</div>
              <div className="print-label-case-qty">CS QTY: {item.case_qty}</div>
            </div>

            <div className="print-label-right-column">
              <div className="print-label-qr-section">
                <QRCodeSVG
                  value={qrUrl}
                  size={100}
                  level="M"
                  includeMargin={false}
                />
                <div className="print-label-qr-text">OPS</div>
              </div>
              <div className="print-label-date">{formattedDate}</div>
            </div>
          </div>

          <div className="print-label-bottom-section">
            <div className="print-label-description">
              {item.description}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div ref={ref} className="print-container" style={{ page: 'label-print' }}>
      <div className="print-page">
        {labels}
      </div>
    </div>
  );
});

function BarcodeImage({ sku }) {
  const svgRef = useRef(null);

  useEffect(() => {
    if (svgRef.current && sku) {
      try {
        JsBarcode(svgRef.current, sku, {
          format: 'CODE128',
          width: 1,
          height: 40,
          displayValue: false,
          margin: 0
        });
      } catch (error) {
        console.error('Barcode generation failed:', error);
      }
    }
  }, [sku]);

  return <svg ref={svgRef}></svg>;
}

// UPC Barcode removed - no longer needed

export default PrintView;